import DialogContent from "./DialogContent";

export default DialogContent;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/dialog/DialogContent/index.js